// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___awqdo","wasteAccompanyingDocumentContainer":"wasteAccompanyingDocumentContainer___e4hl0"};